import { getApiBaseUrl } from './config';

/**
 * Public landing contact: POST /api/user_feedback
 */
export async function submitUserFeedback({ name, email, message }) {
  const base = getApiBaseUrl();
  const url = `${base}/api/user_feedback`;

  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({
      name: String(name || '').trim(),
      email: String(email || '').trim(),
      message: String(message || '').trim(),
    }),
  });

  let payload = null;
  try {
    payload = await response.json();
  } catch {
    payload = null;
  }

  if (!response.ok) {
    const messageText =
      payload?.message || `Error sending message (${response.status})`;
    throw new Error(messageText);
  }

  return payload;
}
